var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-search"},[_c('search-title'),_c('search-field'),_c('search-filters'),_c('search-type'),_c('search-filter-remover'),_c('search-message'),_c('search-hits')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }